function returnIfNotNull(s) {
	if (s === "null" || !s) {
		return undefined;
	} else {
		return s;
	}
}

export default returnIfNotNull;
